import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import svgData from "./svgData";
import { PathElement } from "../../svgHelpers";
const PhotoLibrary = (props) => (_jsxs(_Fragment, { children: [_jsx(PathElement, { ...props, path: svgData.path.d1 }), _jsx(PathElement, { ...props, path: svgData.path.d2 })] }));
export default PhotoLibrary;
